const AgendarCita = {
    VerificarYObtenerDatosDeSolicitante: 'SICCIJ/AgendarCita/VerificarYObtenerDatosDeSolicitante',
    ObtenerConfiguracionesDeArea: 'SICCIJ/AgendarCita/ObtenerConfiguracionesDeArea',
    VerificarDisponibilidadJuzgado: 'SICCIJ/AgendarCita/VerificarDisponibilidadJuzgado',
    ObtenerAgendaEventosBloques: 'SICCIJ/AgendarCita/ObtenerAgendaEventosBloques',
    AgendarCita: 'SICCIJ/AgendarCita/AgendarCita'
  }
  
  const MiAgenda = {
    ObtenerEventosCita: 'SICCIJ/ConsultaDeCitas/ObtenerEventosCita',
    CancelarCita:'SICCIJ/ConsultaDeCitas/CancelarCita'
  }

  const ConsultarCita = {
    VerificarYObtenerCita: 'SICCIJ/ConsultarCita/VerificarYObtenerCita'
  }
  
  const citas = {
    AgendarCita: AgendarCita,
    MiAgenda: MiAgenda,
    ConsultarCita: ConsultarCita
  }
  
  export default citas;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICCIJ/sistema/citas/citas.js
// module id = null
// module chunks = 